// @flow
import { DevicesGroupsActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    group: {},
    listaGroups: [],
    loading: false,
    error: false,
    formSubmited: false
};

type DevicesAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { group?: {} | null, listaGroups?: [] | null, loading?: boolean, +value ?: boolean };

const DevicesGroups = (state: State = INIT_STATE, action: DevicesAction): any => {
    switch (action.type) {
        case DevicesGroupsActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DevicesGroupsActionTypes.GET_GROUP: {
                    return {
                        ...state,
                        group: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DevicesGroupsActionTypes.LIST_GROUPS: {
                    return {
                        ...state,
                        listaGroups: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DevicesGroupsActionTypes.ADD_GROUP: {
                    return {
                        ...state,
                        group: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DevicesGroupsActionTypes.UPDATE_GROUP: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DevicesGroupsActionTypes.DELETE_GROUP: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case DevicesGroupsActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case DevicesGroupsActionTypes.GET_GROUP: {
                    return {
                        ...state,
                        error: action.payload.error,
                        device: {},
                        loading: false,
                    };
                }
                case DevicesGroupsActionTypes.LIST_GROUPS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaDevices: [],
                        loading: false,
                    };
                }
                case DevicesGroupsActionTypes.ADD_GROUP: {
                    return {
                        ...state,
                        device: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DevicesGroupsActionTypes.UPDATE_GROUP: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case DevicesGroupsActionTypes.DELETE_GROUP: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case DevicesGroupsActionTypes.GET_GROUP:
            return { ...state, error: false, loading: true };
        case DevicesGroupsActionTypes.LIST_GROUPS:
            return { ...state, error: false, loading: true };
        case DevicesGroupsActionTypes.ADD_GROUP:
            return { ...state, error: false, loading: true };
        case DevicesGroupsActionTypes.UPDATE_GROUP:
            return { ...state, error: false, loading: true };
        case DevicesGroupsActionTypes.DELETE_GROUP:
            return { ...state, error: false, loading: true };
        case DevicesGroupsActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                group: {},
                listaGroups: [],
                listaPlayers: [],
                listaInteractives: [],
                formSubmited: false,
            };
        default:
            return { ...state };
    }
};

export default DevicesGroups;
